const formatDate = (date) => {
  return `${date.substr(-2, 2)}/${date.substr(5, 2)}/${date.substr(0, 4)}`
}

export default formatDate
